<template>
  <div class="subscription">
      <app-icon :src="icon" size="57px" />
      <div>
          <p class="title">
              {{ name }}
          </p>

          <span
              class="status g-status"
              :class="`g-status_${statusSeverity}`"
          >
              {{ status }}
          </span>
      </div>

      <div class="arrow"></div>
  </div>
</template>

<script>
import AppIcon from '@/components/AppIcon.vue';

export default {
  props: {
    icon: String,
    name: String,
    status: String,
    statusSeverity: {
      type: String,
      validator(value) {
        return ['error', 'success'].includes(value);
      },
    },
  },
  components: {
    AppIcon,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.subscription {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 10px;
  border: 1px solid var(--tertiary-accent);
  border-radius: 5px;
  cursor: pointer;
}

.title {
  font-size: 16px;
  font-weight: 500;
  word-break: break-word;
}

.status {
  font-size: 14px;
  margin-top: 7px;
  word-break: break-word;
}

.arrow {
  width: 10px;
  height: 0;
  margin-left: auto;
  margin-right: 8px;
  margin-top: -2px;
  flex-shrink: 0;

  &:before,
  &:after {
      content: '';
      display: block;
      width: 100%;
      background: #b2b2b2;
      height: 2px;
      transform-origin: right;

      @include dark {
          background: var(--tertiary-accent);
      }
  }

  &:before {
      transform: rotate(45deg) translateY(2px);
  }

  &:after {
      transform: rotate(-45deg) translateY(-2px);
  }
}
</style>
